import GalleryImage from "./GalleryImage";

function Gallery(props){
    return <div className={!props.topOpen? "card card-collapsed" : "card"} id="galleryCard">
        <div className="card_header">
            <a onClick={() => props.toggleCards()} className="card_header_title"><h2>gallery</h2></a>
        </div>
        <div className="card_body">
            <div className="card_body_content">
                <div className="gallery_container">
                    <GalleryImage setImageLightbox={props.setImageLightbox} src="/gallery/diana.png"/>
                    <GalleryImage setImageLightbox={props.setImageLightbox} src="/gallery/powerbomb.jpg"/>
                    <GalleryImage setImageLightbox={props.setImageLightbox} src="/gallery/takingallcomers1bg.png"/>
                    <GalleryImage setImageLightbox={props.setImageLightbox} src="/gallery/takingallcomers2bg.png"/>
                    <GalleryImage setImageLightbox={props.setImageLightbox} src="/gallery/takingallcomers3bg.png"/>
                    <GalleryImage setImageLightbox={props.setImageLightbox} src="/gallery/vatlas2.png" />
                    <GalleryImage setImageLightbox={props.setImageLightbox} src="/gallery/vlane2.png" />
                </div>
            </div>
        </div>
    </div>;
}
export default Gallery;